import { useEffect, useState } from 'react';
import { ShopListItem } from '~/components/ui/ShopListItem';
import { rage } from '~/rage';
import { IClientConfigs, VehicleConsumableGroup, WalletType } from '~/shared';

type Consumable = IClientConfigs['vehicleWear']['consumables'][number];

const ListTabItem = ({
	item,
	index,
	activeCategory,
	activeListIndex,
	handleSelect,
}: {
	item: Consumable;
	index: number;
	activeCategory: VehicleConsumableGroup;
	activeListIndex: number | null;
	handleSelect: (index: number) => void;
}) => {
	const seenTrackerKey = `${activeCategory}.${item.id}`;
	const [isUnseen, setIsUnseen] = useState(
		rage.vehicleServiceStation.isUnseen(seenTrackerKey),
	);

	useEffect(() => {
		if (index === activeListIndex) {
			const seenTrackerKey = `${activeCategory}.${item.id}`;
			rage.vehicleServiceStation.markSeen(seenTrackerKey);
			setIsUnseen(false);
		}
	}, [index, activeListIndex, activeCategory, item.id]);

	return (
		<ShopListItem
			title={item.name}
			price={item.price}
			walletType={WalletType.Cash}
			id={`service-${item.id}`}
			handleClick={() => handleSelect(index)}
			active={index === activeListIndex}
			installed={false}
			isNew={isUnseen}
			key={index}
		/>
	);
};

export { ListTabItem };
